export const CATEGORY_DISPLAY_MAP: Record<string, string> = {
  administration: 'Administration',
  allData: 'All data',
  batchProcessing: 'Batch processing',
  compute: 'Compute',
  containers: 'Containers',
  databases: 'Databases',
  endpointManagement: 'Endpoint management',
  identity: 'Identity',
  logging: 'Logging',
  networking: 'Networking',
  queues: 'Queues',
  serverless: 'Serverless',
  storage: 'Storage',
  threatDetection: 'Threat detection',
  vulnerabilityManagement: 'Vulnerability management',
};
